import '../text';
import { defineCustomElement, getAttribute, getBooleanAttribute, getReactEventHandler, isAttrEqual, isAttrTrue, NectaryElement, updateAttribute, updateBooleanAttribute, updateExplicitBooleanAttribute } from '../utils';
const templateHTML = '<style>:host{display:block;cursor:pointer}:host([disabled]){cursor:initial}#wrapper{all:initial;display:flex;position:relative;box-sizing:border-box;height:40px;width:100%;padding:8px 16px;align-items:center;gap:10px;user-select:none;background-color:var(--sinch-comp-action-menu-color-default-background-initial);--sinch-global-color-text:var(--sinch-comp-action-menu-color-default-text-initial);--sinch-global-color-icon:var(--sinch-comp-action-menu-color-default-icon-initial);--sinch-global-size-icon:var(--sinch-comp-action-menu-size-icon)}:host([data-selected])>#wrapper{background-color:var(--sinch-comp-action-menu-color-default-background-selected)}:host(:hover)>#wrapper{background-color:var(--sinch-comp-action-menu-color-default-background-hover)}:host([disabled])>#wrapper{pointer-events:none;background-color:var(--sinch-comp-action-menu-color-disabled-background-initial);--sinch-global-color-text:var(--sinch-comp-action-menu-color-disabled-text-initial);--sinch-global-color-icon:var(--sinch-comp-action-menu-color-disabled-icon-initial)}#content{flex:1;min-width:0;--sinch-comp-text-font:var(--sinch-comp-action-menu-font-option)}::slotted(*){margin-left:-6px}</style><div id="wrapper" inert><slot name="icon"></slot><sinch-text id="content" type="m" ellipsis></sinch-text></div>';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-action-menu-option', class ActionMenuOption extends NectaryElement {
  #$content;
  #controller = null;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$content = shadowRoot.querySelector('#content');
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const {
      signal
    } = this.#controller;
    this.setAttribute('role', 'option');
    this.addEventListener('mousedown', this.#onMouseDown, {
      signal
    });
    this.addEventListener('-click', this.#onClickReactHandler, {
      signal
    });
  }
  disconnectedCallback() {
    this.#controller.abort();
    this.#controller = null;
  }
  static get observedAttributes() {
    return ['text', 'disabled', 'data-selected'];
  }
  attributeChangedCallback(name, oldVal, newVal) {
    if (isAttrEqual(oldVal, newVal)) {
      return;
    }
    switch (name) {
      case 'text':
        {
          this.#$content.textContent = newVal;
          break;
        }
      case 'disabled':
        {
          updateBooleanAttribute(this, name, isAttrTrue(newVal));
          break;
        }
      case 'data-selected':
        {
          const isDisabled = getBooleanAttribute(this, 'disabled');
          updateExplicitBooleanAttribute(this, 'aria-selected', isAttrTrue(newVal) && !isDisabled);
          break;
        }
    }
  }
  set text(value) {
    updateAttribute(this, 'text', value);
  }
  get text() {
    return getAttribute(this, 'text', '');
  }
  set disabled(isDisabled) {
    updateBooleanAttribute(this, 'disabled', isDisabled);
  }
  get disabled() {
    return getBooleanAttribute(this, 'disabled');
  }
  click() {
    this.#dispatchClickEvent();
  }
  #onMouseDown = () => {
    this.#dispatchClickEvent();
  };
  #dispatchClickEvent() {
    this.dispatchEvent(new CustomEvent('-click'));
  }
  #onClickReactHandler = e => {
    getReactEventHandler(this, 'on-click')?.(e);
  };
});